module.exports = __webpack_public_path__ + "img/Wolt_640x200.59e46b82.jpg";